import script from "./AnchorRead.vue?vue&type=script&setup=true&lang=js"
export * from "./AnchorRead.vue?vue&type=script&setup=true&lang=js"

import "./AnchorRead.vue?vue&type=style&index=0&id=356c0370&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-356c0370"]])

export default __exports__